import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { LIDER_IA_COMPONENTS } from '@/data/liderIAEvaluationData';

const DEFAULT_WEIGHTS: Record<string, number> = Object.fromEntries(
  LIDER_IA_COMPONENTS.map(c => [c.id, c.weight])
);

export function useEvaluationWeights(organizationId: string | null | undefined) {
  const enabled = !!organizationId && organizationId !== 'all';

  const { data: customWeights } = useQuery({
    queryKey: ['evaluation-weights', organizationId],
    queryFn: async () => {
      const { data } = await supabase
        .from('platform_settings')
        .select('value')
        .eq('key', `evaluation_weights_${organizationId}`)
        .maybeSingle();
      if (!data?.value) return null;
      return data.value as Record<string, number>;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  const getWeight = (componentId: string): number => {
    if (customWeights && customWeights[componentId] != null) {
      return customWeights[componentId];
    }
    return DEFAULT_WEIGHTS[componentId] ?? 0;
  };

  const isCustom = !!customWeights;

  return { getWeight, isCustom, customWeights };
}
